import { Box, Select } from "@engaging-tech/components"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { MiscSelectors } from "../../../misc"

const Industry = ({ onAnswer, initialValue }) => {
  const { t } = useTranslation(["organisation_survey"])
  const industries = useSelector(MiscSelectors.getAllIndustries)

  const [selected, setSelected] = useState(
    (initialValue && initialValue.value[0]) || ""
  )

  const handleSelect = e => {
    setSelected(e.target.value)
    onAnswer(e.target.value)
  }

  return (
    <Box mt={[3, 5]}>
      <Select
        label={t("questions.industry", "")}
        defaultValue=""
        value={selected}
        onChange={handleSelect}
      >
        <option disabled value="">
          {t("questions.industry_select", "")}
        </option>
        {industries.map(industry => (
          <option key={industry.id} value={industry.id}>
            {industry.name}
          </option>
        ))}
      </Select>
    </Box>
  )
}

export default Industry
